<template lang="pug">
  el-dialog(
    width="55%"
    :visible.sync="isVisible"
    center=true
  )
    // Logo
    div(slot="title")
      img(style="padding-top: 2%" src="~@/assets/logo.png")
     

    // Login 
    el-form(
      style="padding: 0% 10% 5% 10%"
      :model="form"
      :rules="userRules"
      ref="login"
    )
      // Email
      el-form-item(prop="email")
        el-input(
          v-model="form.email"
          placeholder="Email"
          prefix-icon="el-icon-message"
        )

      // password
      el-form-item(prop="password")
        el-input(
          v-model="form.password"
          type="password"
          placeholder="Password"
        )
          i(:class="$style.fa" slot="prefix" class="fa fa-lock")

      // Remember
      el-row
        el-col(:span="12" align="left")
          el-checkbox(v-model="isRemember") Remember Me

    // Submit button
    el-row
      el-col(align="middle")
        el-button(
          class="primary-button"
          :loading="isLoading"
          @click="login('login')"
        ) Login
</template>

<script>
export default {
  name: 'Login',

  props: {
    showLogin: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      text: '',
      userRules: {
        email: [
           { required: true, message: 'Please input the email address.', trigger: 'blur,change' },
        ],
        password: [
          { required: true, message: 'Please input the password.', trigger: 'blur,change' },
        ],
      },
      
      isRemember: true,
      isLoading: false,
    }
  },

  computed: {
    isVisible: {
      get() {
        return this.showLogin
      },
      set(value) {
        if (value === false) {
          this.$emit('closeLogin')
        }
      },
    },
  },

  methods: {
    login(formName) {
      this.isLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios.post('/api/login', this.form)
            .then((result) => {
              this.isLoading = false
              this.$store.commit('setAdminInfo', result.data.user)
              this.axios.defaults.headers.common['X-CSRF-TOKEN'] = result.data.csrfToken
              this.$emit('onLogin', true)
            })
            .catch((error) => {
              this.isLoading = false
              this.$emit('onLogin', false)
            })
        } else {
          return false
        }
      })
    },   
  },
}
</script>



<style module>

  .fa {
    height: 100%;
    line-height: 40px;
    width: 25px;
    text-align: center;
  }
</style>
